import { Component, computed, inject } from '@angular/core';
import { LocaleService } from '@core/services/locale.service';
import { AuthStore } from '@core/store/core/auth.store';
import { PopupMenuComponent, ThemeService } from '@mmscan/design-system';
import { TranslateService } from '@ngx-translate/core';
import { type MenuItem, PrimeIcons } from 'primeng/api';

@Component({
  selector: 'mp-settings-buttons',
  imports: [PopupMenuComponent],
  templateUrl: './settings-buttons.component.html',
})
export class SettingsButtonsComponent {
  protected themeService = inject(ThemeService);
  protected authStore = inject(AuthStore);
  protected localeService = inject(LocaleService);
  private translate = inject(TranslateService);

  protected primeIcons = PrimeIcons;

  themeIcon = computed(() => (this.themeService.theme() === 'dark' ? PrimeIcons.MOON : PrimeIcons.SUN));
  themeLabel = computed(() =>
    this.translate.instant(this.themeService.theme() === 'dark' ? 'nav.settings.dark' : 'nav.settings.light')
  );

  /** Label of the currently active language; pressing it switches to the other one. */
  languageLabel = computed(() =>
    this.translate.instant(
      this.authStore.userLocale() === 'EN_CA' ? 'nav.settings.languageEnglish' : 'nav.settings.languageFrench'
    )
  );

  items = computed<MenuItem[]>(() => {
    this.localeService.locale();

    return [
      {
        label: this.translate.instant('nav.settings.title'),
        items: [
          {
            label: this.themeLabel(),
            icon: this.themeIcon(),
            command: () => this.switchTheme(),
          },
          {
            label: this.languageLabel(),
            icon: PrimeIcons.GLOBE,
            command: () => this.switchLanguage(),
          },
        ],
      },
    ];
  });

  switchTheme(): void {
    this.themeService.toggleTheme();
  }

  switchLanguage(): void {
    this.authStore.switchLocale();
  }
}
